// react
import React from 'react';

// third-party
import { connect } from 'react-redux';
// import { FormattedMessage } from 'react-intl';

// application
import Dropdown from './Dropdown';
import { currencyChange } from '../../store/currency';

// data stubs
import currencies from '../../data/shopCurrencies';

function DropdownCurrency(props) {
    const { currency, currencyChange: changeCurrency } = props;

    const title = (
        <React.Fragment>
            <div className='row mr-2'>
                <div className='col-sm-1'><img height={15} width={30} src="images/moneda.png" alt="Moneda" /></div>
                <div className='col-sm-1'><span className="topbar__item-value float-left"> &nbsp;{ currency.code}</span></div>
            
            </div>
             
        </React.Fragment>
    );

    return (
        <Dropdown
            title={title}
            items={currencies}
            onClick={(item) => changeCurrency(item.currency)}
        />
    );
}

const mapStateToProps = (state) => ({
    currency: state.currency,
    locale: state.locale,
});

const mapDispatchToProps = {
    currencyChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(DropdownCurrency);
